import React from 'react'
import Navber from '../Components/Navber.jsx'

function Tour_page() {
  return (
    <div style={{ backgroundColor: "#f0f0f0", minHeight: "100vh" }}>
        <Navber />
                <div className='weekend_container'>
            <h1>Weekend Tour</h1>
        </div>
    </div>
  )
}

export default Tour_page